import { Card, Stack, Typography } from '@mui/material'
import React                       from 'react'
import MessageStatusBadge          from './MessageStatusBadge'
import Box                         from '@mui/material/Box'
import { useTranslation }          from 'react-i18next'
import Button                      from '@mui/material/Button'
import { isRunningOnDev }          from '../utils/utils'
import { Link as RouterLink }      from 'react-router-dom'

export default function ContentWidget( { id, title, content, message, transaction, sx, other } ) {

  const {t} = useTranslation()

  return <Card
    component={Stack}
    sx={{
      p: 2,
      borderRadius: 1,
      ...sx,
    }}
    {...other}
  >
    <Typography variant="subtitle2">{title}</Typography>
    <Typography variant="body2" sx={{ color: 'text.disabled' }}>
      {content}
    </Typography>
    {message && <Box my={1}>
      <MessageStatusBadge t={t} message={message} />
    </Box>}
    <Stack direction={'row'} gap={2} sx={{ justifyContent: "end", alignItems: "center", }}>
      {transaction && <Button size="small" variant={'outlined'} to={`/transactions/${transaction.id}`} component={RouterLink}>{t('Show transaction')}</Button>}
      {message && <>
        {id !== message.id && <Button size="small" variant={'outlined'} to={`/messages/${message.id}`} component={RouterLink}>{t('Show SMS')}</Button>}
        {message.parentId && <Button size="small" variant={'outlined'} to={`/messages/${message.parentId}`} component={RouterLink}>{t('Show parent SMS')}</Button>}
        <Button size="small" variant={'contained'} disabled={!message.foreignId} component={'a'} target={'_blank'} href={`https://${isRunningOnDev() ? 'smshub' : 'central'}.mediatex.sk/frontend/dashboard/messages/${message.foreignId}`}>{t('Show external SMS')}</Button>
      </>}
    </Stack>
  </Card>
}